export default __webpack_public_path__ + "static/media/JSClogo.62029b1c.png";